/*
 * @Description: 没啥，就是把常用的方法统一封到一个地方导出，省的代码冗余
 * @Date: 2020-05-21 10:34:59
 * @LastEditTime: 2020-05-21 10:43:43
 */
import getKsBridge from '../bridge';
import webLogger from '../logger';
import cookie from '../cookie';
import openOrDownload from '../openOrDownload';
import request from '../request';
import compareAppVersion from '../compareAppVersion';


export { getKsBridge, webLogger, cookie, openOrDownload, request, compareAppVersion };
